require('../tooltip/tooltip.css');
module.exports = require('./index-nocss.js');



// WEBPACK FOOTER //
// ./src/app/common/core/vendor/angular-ui-bootstrap/src/popover/index.js